<template>
  <div>
    <div class="isis-page__header">
      <div class="nav-link" @click="goToPreviousPage">
        <i class="fas fa-chevron-left"></i>
        <span>{{ $t("task_management.edit_main_task") }}</span>
      </div>
    </div>
    <MainPage ref="editMainPage" mode="edit" @manageTask="editTask"></MainPage>
  </div>
</template>
<script>
import { hasHistory, Message } from "@/helpers/utils";
import MainPage from "../Component/MainPage";
import { service_names } from "@/constants/Services";

export default {
  components: {
    MainPage
  },
  data() {
    return {};
  },

  methods: {
    goToPreviousPage() {
      this.$router.push("/task-management");
    },
    editTask(data, id) {
      this.$axios
        .patch(`${service_names.school}/main-task/${id}`, data)
        .then(() => {
          Message.success(this.$t("common.update_success"));
          this.$refs.editMainPage.fetchMainTask();
        })
        .catch(() => {
          this.$refs.editMainPage.fetchMainTask();
        });
    }
  }
};
</script>
